export default "__VITE_ASSET__BMIY5Sry__"